/**
 * documentsApi — document writes, on Symfony (`/api/v1/user/document…`, or the
 * org-scoped routes when an administrator edits a member — `credentialsApi`
 * picks the scope).
 *
 * The server owns what the legacy PHP actions used to compute: TSA and Basic
 * Med expiries, the reminder times, the per-type required fields and the
 * duplicate-number check (symphony-holdshort `5a63c81e`). The page sends what
 * the user typed; the reply and the reload show what was stored.
 *
 * Attachments upload to the image or file endpoint by extension, as the
 * legacy uploader routed them.
 */
import CredentialsApi from './credentialsApi.js';
import { uploadKindOf } from './attachments.js';

export const addDocument = body => CredentialsApi.createDocument(body);
export const saveDocument = (documentId, body) => CredentialsApi.updateDocument(documentId, body);
export const deleteDocument = documentId => CredentialsApi.removeDocument(documentId);

/** Attach a scan to an existing document (the dialog offers it after the first save). */
export const uploadDocumentAsset = (documentId, file) =>
	CredentialsApi.uploadDocumentAsset(documentId, file, uploadKindOf(file));
